var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgChevronRight(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    focusable: "false"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.55556 1.31733c-.57258.39977-.72788 1.21088-.34687 1.81166a1.29715 1.29715 0 00.14434.18747l8.05484 8.68351-8.05482 8.6835c-.47971.51715-.46904 1.34442.02385 1.84775a1.2586 1.2586 0 00.17866.15144c.72375.50533 1.68795.3978 2.2943-.25587l8.7763-9.46138c.49846-.53738.49846-1.3935-.00001-1.93087l-8.7763-9.46133C10.2435.91955 9.2793.81201 8.55555 1.31733z",
    fill: "#000",
    fillRule: "nonzero"
  })));
}

export default __webpack_public_path__ + "ondemand/static/e3056e037/icons/chevron-right.svg";
export { SvgChevronRight as ReactComponent };